import { IActivityEventDataType as CommonActivityEventDataType } from '../../../../common/scripts/Config/ActivityConfigType';
import { TimeRangeOption } from '../../../../tableEngine/Script/Game/UI/TimeRangeDropdown';

export enum FeatureActivityEventName {
    // common
    // to use in editor inspector
    None = 'none',
    ClosePage = 'close_page',
    OpenTutorial = 'open_tutorial',
    SkipTutorial = 'skip_tutorial',

    // outer lobby
    ClickBanner = 'click_banner',

    // inner lobby
    ClickPlayType = 'click_play_type',
    EnterGame = 'enter_game',
    ClickFreePlay = 'click_free_play',
    ClickQuickStart = 'click_quick_start',
    OpenHistoryRecordList = 'open_history_record_list',
    OpenHistoryDetail = 'open_history_detail',
    OpenCrowdPlayHistoryDetail = 'open_crowd_play_history_detail',
    SwitchHistoryQueryTimeRange = 'switch_history_query_time_range',
    OpenJackpotPage = 'open_jackpot_page',
    OpenJackpotRecordPage = 'open_jackpot_record_page',
    OpenLobbyGameRulePage = 'open_lobby_game_rule_page',
    OpenGameRulePage = 'open_game_rule_page',
}

export interface IFeatureActivityEventDataType extends CommonActivityEventDataType {
    // common
    [FeatureActivityEventName.None]: FeatureActivityDataType.Empty;
    [FeatureActivityEventName.ClosePage]: FeatureActivityDataType.PageInfo;
    [FeatureActivityEventName.OpenTutorial]: FeatureActivityDataType.TutorialInfo;
    [FeatureActivityEventName.SkipTutorial]: FeatureActivityDataType.TutorialInfo;

    // outer lobby
    [FeatureActivityEventName.ClickBanner]: FeatureActivityDataType.BannerInfo;

    // inner lobby
    [FeatureActivityEventName.EnterGame]: FeatureActivityDataType.EnterGameInfo;
    [FeatureActivityEventName.ClickFreePlay]: FeatureActivityDataType.Empty;
    [FeatureActivityEventName.ClickQuickStart]: FeatureActivityDataType.Empty;
    [FeatureActivityEventName.OpenHistoryRecordList]: FeatureActivityDataType.MachineRecordInfo;
    [FeatureActivityEventName.OpenHistoryDetail]: FeatureActivityDataType.HistoryDetailInfo;
    [FeatureActivityEventName.OpenCrowdPlayHistoryDetail]: FeatureActivityDataType.OpenCrowdPlayHistoryDetailInfo;
    [FeatureActivityEventName.SwitchHistoryQueryTimeRange]: FeatureActivityDataType.HistoryTimeRangeFilterInfo;
    [FeatureActivityEventName.OpenJackpotPage]: FeatureActivityDataType.OpenJackpotPageInfo;
    [FeatureActivityEventName.OpenJackpotRecordPage]: FeatureActivityDataType.Empty;
    [FeatureActivityEventName.OpenLobbyGameRulePage]: FeatureActivityDataType.Empty;
    [FeatureActivityEventName.OpenGameRulePage]: FeatureActivityDataType.Empty;
}

export namespace FeatureActivityDataType {
    // common
    export type Empty = {};
    export type PageInfo = {
        PageTitle: string;
    };
    export type TutorialInfo = {
        TutorialID: string;
    };
    export type OpenJackpotPageInfo = {
        From: 'lobby' | 'game';
    };

    // outer lobby
    export type BannerInfo = {
        TableID?: string;
        GameID?: string;
        HallID?: string;
        URL?: string;
        Jackpot?: boolean;
    };

    // inner lobby
    export type EnterGameInfo = {
        From: EnterGameLocation;
    };
    export type MachineRecordInfo = {
        MachineInfo?: MachineInfo;
        JP?: true;
    };
    export type MachineInfo = {
        MachineName: string;
        MachineID: number;
    };
    export type MachineID = {
        MachineID: number;
    };
    export type HistoryDetailInfo = {
        TransactionID: string;
    };
    export type HistoryTimeRangeFilterInfo = {
        TimeRange: TimeRangeOption;
        MachineID: number;
    };
    export type OpenCrowdPlayHistoryDetailInfo = {
        CrowdPlayID: string;
    };

    // enums
    export enum ExitGameLocation {
        ExitButton = 'exit_button',
        ExitButtonInMenu = 'exit_button_in_menu',
        CrowdPlaySettingPopup = 'crowd_play_setting_popup',
    }

    export enum EnterGameLocation {
        OuterLobby = 'outer_lobby',
        TableList = 'table_list',
        MachineRecord = 'machine_record',
        ResumeGamePopup = 'resume_game_popup',
    }
}
